// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
nav {
  padding: 30px;
}
nav a {
  font-weight: bold;
  color: #2c3e50;
}
nav a.router-link-exact-active {
  color: #42b983;
}
`, "",{"version":3,"sources":["webpack://./src/App.vue"],"names":[],"mappings":";AA2BA;EACA,iDAAA;EACA,mCAAA;EACA,kCAAA;EACA,kBAAA;EACA,cAAA;AACA;AAEA;EACA,aAAA;AACA;AAEA;EACA,iBAAA;EACA,cAAA;AACA;AAEA;EACA,cAAA;AACA","sourcesContent":["<template>\n  <div id=\"app\">\n    <nav>\n      <router-link to=\"/\">Home</router-link> |\n      <router-link to=\"/about\">About</router-link> |\n      <router-link to=\"/users\">\n        Go to User List\n      </router-link>\n      <router-link to=\"/add-user\"> |\n        Add New User\n      </router-link>\n    </nav>\n    <router-view />\n  </div>\n</template>\n\n\n<script>\nexport default {\n  name: 'App',\n  async created() {\n    await this.$store.dispatch('fetchUsers');\n  },\n\n};\n</script>\n<style>\n#app {\n  font-family: Avenir, Helvetica, Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-align: center;\n  color: #2c3e50;\n}\n\nnav {\n  padding: 30px;\n}\n\nnav a {\n  font-weight: bold;\n  color: #2c3e50;\n}\n\nnav a.router-link-exact-active {\n  color: #42b983;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
